import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";

import "ui-components/form-elements/input/wow-input";
import "ui-components/form-elements/textarea/textarea";
import "ui-components/media-uploader/media-uploader";

import { styles } from "./live-event-preview.css";
import { SignalElement, inject } from "ui-common/di";
import type { ILiveEventFormState, ILiveEventFormService } from "ui-common/services/live-event-form/types";
import { handleFormInput, handleFormBlur } from "ui-common/form/form-utils";
import { t } from "../../../translations/i18n";

@customElement("live-event-preview")
export class LiveEventPreview extends SignalElement {
  static override styles = [styles];

  @property({ type: Boolean })
  isMobile = false;

  @inject<ILiveEventFormState>("liveEventFormState")
  private state!: ILiveEventFormState;

  @inject<ILiveEventFormService>("liveEventFormService")
  private service!: ILiveEventFormService;

  private handleThumbnailUpload(event: CustomEvent): void {
    this.service.setThumbnailData(event.detail.fileId);
  }

  override render() {
    const formData = this.state.formData.get();
    const errors = this.state.validationErrors.get();
    const thumbnailUrl = this.state.thumbnailUrl.get();

    return html`
      <div class="preview-fields ${this.isMobile ? "mobile" : "desktop"}">
        <span class="upload-label">${t("createLiveEventPage.cover")}</span>
        <span class="upload-helper-text">${t("createLiveEventPage.coverHelperText")}</span>
        <div class="cover-uploader-container">
          <media-uploader
            responsive
            context="cover_image"
            allowedMediaType="image"
            label=${t("createLiveEventPage.uploadImage")}
            viewport="cover"
            currentFileUrl=${thumbnailUrl}
            @change=${this.handleThumbnailUpload}
          ></media-uploader>
        </div>
        ${errors.thumbnail ? html`<span class="thumbnail-error">${errors.thumbnail}</span>` : nothing}
        <div class="cover-uploader-divider"></div>
        <div class="preview-panel-content">
          <wow-input
            label=${t("createLiveEventPage.title")}
            placeholder=${t("createLiveEventPage.titlePlaceholder")}
            .value=${formData.title}
            error-message=${errors.title || ""}
            maxlength="50"
            @input=${(e: Event) => handleFormInput(this.service, "title", e)}
            @blur=${() => handleFormBlur(this.service, "title")}
          ></wow-input>
          <wow-textarea
            label=${t("createLiveEventPage.description")}
            placeholder=${t("createLiveEventPage.descriptionPlaceholder")}
            rows="3"
            maxlength="250"
            autogrow
            .value=${formData.description}
            error-message=${errors.description || ""}
            @input=${(e: Event) => handleFormInput(this.service, "description", e)}
            @blur=${() => handleFormBlur(this.service, "description")}
          ></wow-textarea>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "live-event-preview": LiveEventPreview;
  }
}
